module.exports = __webpack_public_path__ + "39afff4f90646faf3d604f73bd9d3439.svg";